/*
 * @Author: DQL
 * @Date: 2021-05-01 14:24:48
 * @LastEditors: DQL
 * @LastEditTime: 2021-05-01 14:25:25
 * @Description: file content
 */
import axios from 'axios';
import config from '@/config.js';

const { commontCtx } = config;

export const roleTypeService = {
  // 查询列表
  list: (params) => { return axios.get(`${commontCtx}/roleType/query`, { params: params }); },

  // 新增
  save: (params) => { return axios.post(`${commontCtx}/roleType/save`, params); },

  // 修改
  update: (params) => { return axios.put(`${commontCtx}/roleType/update`, params); },

  // 删除
  delete: (roleTypeDm) => { return axios.delete(`${commontCtx}/roleType/delete/${roleTypeDm}`); }
};
